import React, { useEffect, useMemo } from 'react';
import moment from 'moment';

import { identity, parseNumberToPrice } from 'utils';
import { IncentiveAgreementDetailsDrawerProps } from 'types/technicalLicenses/editTechnicalLicense';
import { Input } from 'components/components';
import { formatSlashMDY } from '../../../utils/constants/formatters';
import { getTechnicalLicenseFile } from '../../utils';
import { DetailsDrawerRow, TLHIAUploadForm } from '..';

import './IncentiveAgreementDetailsDrawer.scss';

const IncentiveAgreementDetailsDrawer = (props: IncentiveAgreementDetailsDrawerProps) => {
  const { incentiveAgreement, technicalLicenseID, incentiveAgreementStatus } = props;
  const {
    startDate: iaStartDate,
    endDate: iaEndDate,
    file,
    walletAmount,
  } = incentiveAgreement;

  useEffect(() => {
    if (identity.isPositiveNumber(technicalLicenseID)) {
      props.actions.getIncentiveAgreementById();
    }
  }, [technicalLicenseID]);

  const isApproved = useMemo(() => incentiveAgreementStatus === 1, [incentiveAgreementStatus]);
  const startDate = useMemo(() => (identity.isTruthyString(iaStartDate) ? moment(iaStartDate).format(formatSlashMDY) : 'Not specified'), [iaStartDate]);
  const endDate = useMemo(() => (identity.isTruthyString(iaEndDate) ? moment(iaEndDate).format(formatSlashMDY) : 'Not specified'), [iaEndDate]);

  if (!isApproved) {
    return <TLHIAUploadForm incentiveAgreement={incentiveAgreement} technicalLicenseID={technicalLicenseID} />;
  }

  return (
    <div className="incentive-agreement-details-drawer">
      <DetailsDrawerRow label="Start Date" item={startDate} />
      <DetailsDrawerRow label="End Date" item={endDate} />
      <DetailsDrawerRow label="Wallet Amount" item={parseNumberToPrice(walletAmount, 'AED')} />
      <Input.DraggerUpload
        previewType="image"
        defaultFileList={[...getTechnicalLicenseFile(file)]}
        isRoundableButton
      />
    </div>
  );
}

export default IncentiveAgreementDetailsDrawer;
